import { Hierarchy } from '../../types';
import { AccordionMenuData } from '../../components/ui/layout/navigation/submenu/AccordionMenu';

export const hierarchy2DocMenu = (
  hierarchy: Hierarchy[],
): AccordionMenuData => {
  return hierarchy.map((item) => {
    return {
      title: item.legalJurisdiction.name,
      links: item.funds.map((fund) => {
        return {
          title: fund.name,
          url: `/documents/fund/${fund.fundId}`,
        };
      }),
    };
  });
};
